// extracted by mini-css-extract-plugin
module.exports = {"replyTemplateDropdown":"styles__replyTemplateDropdown___3TWnW","templateName":"styles__templateName___3YZ2Y"};